export const CAB_CATEGORY = `admin/cabs/addCabCategory`;
export const GET_CAB_CATEGORY = `admin/cabs/getAllCabCategories`;

export const ADD_CABS = `admin/cabs/addCabs`;
export const GET_ALL_CABS = `admin/cabs/getAllCabs`;


export const ADD_DRIVER = `admin/driver`;
export const GET_ALL_DRIVER= `admin/driver`;

export const GET_All_STATES = `admin/state`;

export const GET_CITY_BY_STATE = `admin/city/city-by-state`;
export const ADD_CITY = `admin/city/add-city`;
export const CITY_LIST = `admin/city/city-list`;
export const ADD_CITY_DISTANCE = `admin/city/add-city-distance`;

export const LOCAL_PACKAGES = `admin/localpackage/`;
export const GET_ALL_FARE_DETAILS = `admin/fare/get-all-fare`;
export const SEARCH_VEHICLE_FARE = `admin/fare/search-cab`;

export const ADD_BOOKING = `admin/booking/add`;
export const ADD_CAB_SEARCH_DATA = `admin/fare/save-cab-search-data`;

export const GET_BOOKING_DETAILS_BY_ID = `admin/booking/booking-details`;

export const GET_CITY_DISTANCE = `admin/distance/get-city-distance`;

export const ADD_ATTACH_TAXI = `admin/attachtaxi/add`;